<template>
    <div class="h100p">
        <el-header>
            <h1>
                <img :src="pageConfig.icon ? pageConfig.icon : require('../assets/img/logo.png')" alt="" style="width:38px;margin-top:-3px;" />
                {{pageConfig.name}}
            </h1>
            <el-dropdown class="headerRight" trigger="click" @command="logout">
                <span class="el-dropdown-link">
                    <img src="https://cube.elemecdn.com/9/c2/f0ee8a3c7c9638a54940382568c9dpng.png" />
                    <span style="cursor:pointer;color:#0070de">{{ userAlias }}</span>
                </span>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item>{{ logoutTextConfig.name }}</el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
        </el-header>
        <el-container>
            <el-aside width="200px">
                <div class="push-button">
                    <i class="el-icon-s-fold show-btn" @click="foldMenu"></i>
                    <i class="el-icon-s-unfold" @click="expandMenu"></i>
                </div>
                <el-menu class="h100p" background-color="#1a2737" text-color="#fff" active-text-color="rgb(0 129 255)" :default-openeds="['1', '2', '3', '4']" :default-active="this.$route.path" router>
                    <el-submenu index="1" v-hasPermi="['menu:arrangement']">
                        <template slot="title">
                            <span>{{ menuTextConfig.exam.name }}</span>
                        </template>
                        <el-menu-item index="/subject" v-hasPermi="['menu:arrangement:subject']">{{ menuTextConfig.exam.subject }}</el-menu-item>
                        <el-menu-item index="/arrangeExam" v-hasPermi="['menu:arrangement:exam']">{{ menuTextConfig.exam.arrangement }}</el-menu-item>
                        <el-menu-item index="/achievement" v-hasPermi="['menu:arrangement:result']">{{ menuTextConfig.exam.achievement }}</el-menu-item>
                    </el-submenu>
                    <el-submenu index="2" v-hasPermi="['menu:questionBank']">
                        <template slot="title">
                            <span>{{ menuTextConfig.questionBank.name }}</span>
                        </template>
                        <el-menu-item index="/questionBank" v-hasPermi="['menu:questionBank:bank']">{{ menuTextConfig.questionBank.questionBank }}</el-menu-item>
                        <el-menu-item index="/questionTag" v-hasPermi="['menu:questionBank:question:tag']">{{ menuTextConfig.questionBank.questionTag }}</el-menu-item>
                        <el-menu-item index="/testPaper" v-hasPermi="['menu:questionBank:testPaper']">{{ menuTextConfig.questionBank.testPaper }}</el-menu-item>
                    </el-submenu>
                    <el-menu-item index="/trainingEnvironment" v-hasPermi="['menu:training']">
                        <template slot="title">
                            <span>{{ menuTextConfig.training }}</span>
                        </template>
                    </el-menu-item>
                    <el-menu-item index="/teacher"  v-has-permi="['tipdm:user:menu']">
                        <template slot="title">
                            <span>{{ menuTextConfig.reviewer }}</span>
                        </template>
                    </el-menu-item>
                    <el-menu-item index="/marking" v-hasPermi="['menu:review']">
                        <template slot="title">
                            <span>{{ menuTextConfig.review }}</span>
                        </template>
                    </el-menu-item>
                    <!-- <el-submenu index="4">
            <template slot="title">
              <span>用户管理</span>
            </template>
            <el-menu-item index="/">考生管理</el-menu-item>
            <el-menu-item index="/">后台用户管理</el-menu-item>
          </el-submenu> -->
                </el-menu>
            </el-aside>
            <el-main>
                <router-view></router-view>
            </el-main>
        </el-container>
    </div>
</template>

<script>
export default {
    name: 'Home',
    data() {
        return {
            userAlias: '',
            isRouterAlive: true,
            pageConfig: {
                name: '',                      // 名称，原：1+X证书考试系统
                icon: '',                      // 图标（为空则按照原设计）
            },
        }
    },
    computed: {
        logoutTextConfig() {
            return this.$store.state.global.textConfig.logout
        },
        menuTextConfig() {
            return this.$store.state.global.textConfig.backend.menu
        }
    },
    created() {
        if (localStorage.getItem('1+XUserIdentity') !== 'Candidate' && window.location.pathname === '/') {
            let permissions = JSON.parse(localStorage.getItem('1+XPermissionsList'))
            if (permissions) {
                if (permissions.includes("menu:arrangement:subject")) {
                    this.$router.push('/subject')
                } else if (permissions.includes("menu:arrangement:exam")) {
                    this.$router.push('/arrangeExam')
                } else if (permissions.includes("menu:arrangement:result")) {
                    this.$router.push('/achievement')
                } else if (permissions.includes("'menu:questionBank:bank")) {
                    this.$router.push('/questionBank')
                } else if (permissions.includes("menu:questionBank:question:tag")) {
                    this.$router.push('/questionTag')
                } else if (permissions.includes("menu:questionBank:testPaper")) {
                    this.$router.push('/testPaper')
                } else if (permissions.includes("menu:training")) {
                    this.$router.push('/trainingEnvironment')
                } else if (permissions.includes("tipdm:user:menu")) {
                    this.$router.push('/teacher')
                } else if (permissions.includes("menu:review")) {
                    this.$router.push('/marking')
                }
            }
        }

        this.userAlias = localStorage.getItem('1+XAdministration')
        let config = this.$store.state.projectConfig
        this.pageConfig = config.page
    },
    provide () { return { reload: this.reload } },
    methods: {
        reload () {
            this.isRouterAlive = false
            this.$nextTick(() => (this.isRouterAlive = true))
        },
        logout() {
            sessionStorage.clear()
            localStorage.removeItem('1+XUserIdentity')
            localStorage.removeItem('1+XAdministration')
            localStorage.removeItem('1+XPermissionsList')
            window.location.href = '/logout'
        },
        /** 展开菜单 */
        expandMenu() {
            document.getElementsByClassName("el-aside")[0].classList.remove("fold")
            let btn = document.getElementsByClassName("push-button")[0]
            btn.getElementsByClassName("el-icon-s-fold")[0].classList.add("show-btn")
            btn.getElementsByClassName("el-icon-s-unfold")[0].classList.remove("show-btn")
            btn.style.borderTopRightRadius = '0px'
            btn.style.borderBottomRightRadius = '0px'
        },
        /** 折叠菜单 */
        foldMenu() {
            document.getElementsByClassName("el-aside")[0].classList.add("fold")
            let btn = document.getElementsByClassName("push-button")[0]
            btn.getElementsByClassName("el-icon-s-unfold")[0].classList.add("show-btn")
            btn.getElementsByClassName("el-icon-s-fold")[0].classList.remove("show-btn")
            btn.style.borderTopRightRadius = '5px'
            btn.style.borderBottomRightRadius = '5px'
        },
    }
}
</script>

<style scoped>
.el-header {
    color: #0070de;
    line-height: 60px;
    display: flex;
    justify-content: space-between;
    padding: 0 20px;
    font-size: 15px;
}
.el-header h1 {
    font-weight: 600;
    font-size: 20px;
}
.headerRight img {
    height: 40px;
    width: 40px;
    object-fit: cover;
    border-radius: 50%;
    margin-right: 12px;
}
.el-container {
    height: calc(100% - 60px);
}
.el-aside {
    color: #333;
    overflow: visible;

    transition-property: width;
    transition-duration: 0.3s;
    transition-timing-function: ease-in-out;
}
.fold {
    width: 10px !important;
}
.el-menu-item.is-active {
    background-color: rgb(21, 31, 44) !important;
}
.el-main {
    color: #333;
    width: 100%;
    background: #f7f7f7;
}

.push-button {
    position: relative;
    width: calc(100% - 1px);
    min-width: 30px;
    color: #ffffff;
    background-color: rgb(26, 39, 55);
    text-align: center;
    border-bottom: 1px solid #ffffff;
}

.push-button i {
    width: 100%;
    height: 100%;
    display: none;
    font-size: 20px;
    line-height: 40px;
    cursor: pointer;
}

.show-btn {
    display: inline-block !important;
}
</style>
